var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0731 12.8612L13.3119 7.62241C12.4305 7.25441 11.63 6.71675 10.956 6.03999C10.2789 5.36581 9.74104 4.56508 9.37289 3.68336L4.13406 8.9222C3.72535 9.33091 3.52064 9.53561 3.34498 9.76087C3.13751 10.0267 2.95961 10.3143 2.81443 10.6187C2.69189 10.8765 2.60052 11.1513 2.41777 11.6996L1.45302 14.5917C1.40861 14.7241 1.40203 14.8663 1.43399 15.0023C1.46596 15.1382 1.53522 15.2626 1.63398 15.3613C1.73274 15.4601 1.85708 15.5293 1.99304 15.5613C2.129 15.5933 2.27118 15.5867 2.4036 15.5423L5.29573 14.5775C5.84468 14.3948 6.11881 14.3034 6.37664 14.1809C6.68123 14.0357 6.96881 13.8579 7.23443 13.6503C7.45968 13.4747 7.66439 13.2699 8.0731 12.8612ZM14.7654 6.16891C15.2878 5.64656 15.5812 4.9381 15.5812 4.19939C15.5812 3.46067 15.2878 2.75221 14.7654 2.22986C14.2431 1.70752 13.5346 1.41406 12.7959 1.41406C12.0572 1.41406 11.3487 1.70752 10.8264 2.22986L10.1981 2.85816L10.225 2.93678C10.5346 3.82271 11.0413 4.6268 11.7069 5.28845C12.3883 5.9739 13.2205 6.49057 14.1371 6.7972L14.7654 6.16891Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.7f9c4e6862dbe151a4ec3914c2ad6508.svg";
export { ForwardRef as ReactComponent };